module.exports = __webpack_public_path__ + "img/btn_order_part_close.0072ea42.svg";